import axios from "axios";
import { useAuth } from "@clerk/react";
import { useMemo, useRef } from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useApi() {
  const { getToken } = useAuth();
  const ref = useRef(getToken);
  ref.current = getToken;
  return useMemo(() => {
    const inst = axios.create({ baseURL: API });
    inst.interceptors.request.use(async (cfg) => {
      const t = await ref.current();
      if (t) cfg.headers.Authorization = `Bearer ${t}`;
      return cfg;
    });
    return inst;
  }, []);
}

export const errMsg = (e, fallback = "Operazione non riuscita") => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return `Valori non validi: ${d.map((x) => x?.loc?.[x.loc.length - 1]).filter(Boolean).join(", ")}`;
  return typeof d === "string" ? d : fallback;
};
